<template>
  <li @click="onClick" class="flex items-center justify-between hover:bg-slate-100 rounded-lg p-2 cursor-pointer">
    <span class="flex items-center space-x-2 w-full">
      <base-avatar :src="item.image" :icon="item.icon" />
      <div class="w-full">
        <span class="font-bold">{{ item.name }}</span>
        <span class="block text-sm text-slate-700">{{ item.description }}</span>
      </div>
    </span>
    <span class="flex-shrink-0">
      <base-icon name="chevronright" />
    </span>
  </li>
</template>

<script>
export default {
  name: 'NotificationListItem',
  props: {
    item: {
      type: Object,
      require: true
    }
  },
  methods: {
    onClick: function () {
      this.$emit('select', this.item)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
